import { AutogenModelQuoteOrder, AutogenRowQuoteOrder } from "./autogen/AutogenModelQuoteOrder";

export class ModelQuoteOrder extends AutogenModelQuoteOrder<RowQuoteOrder> {
    constructor() {
        super(RowQuoteOrder);
    }
}

export class RowQuoteOrder extends AutogenRowQuoteOrder {
}